import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { IssueTemplate } from 'types';

type UpdateIssueTemplateData = {
  name?: string;
  description?: string;
  projectId?: string;
  issueType?: 'task' | 'story' | 'bug' | 'epic' | 'sub-task';
  templateData?: {
    title?: string;
    description?: string;
    priority?: 'low' | 'medium' | 'high';
    status?: 'to do' | 'in progress' | 'in review' | 'blocked' | 'done';
    labels?: string[];
    components?: string[];
    fixVersions?: string[];
    affectsVersions?: string[];
    environment?: 'development' | 'staging' | 'production';
    assignee?: string;
    dueDate?: string;
    epicLink?: string;
    customFields?: Record<string, unknown>;
  };
  isDefault?: boolean;
};

const updateIssueTemplate = async (
  templateId: string,
  updateData: UpdateIssueTemplateData
): Promise<IssueTemplate> => {
  const { data } = await customAxios.patch<IssueTemplate>(
    `/issue-templates/${templateId}`,
    updateData
  );
  return data;
};

export const useUpdateIssueTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      templateId,
      updateData,
    }: {
      templateId: string;
      updateData: UpdateIssueTemplateData;
    }) => updateIssueTemplate(templateId, updateData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['issue-templates'] }).catch(() => undefined);
    },
  });
};
